<template>
  <div id="app" class="variant-pd10913">
    <nav class="variant-nav">
      <BackToLandingPageLink id="header-logo-link">
        <InlineSvg class="variant-nav__logo" src="images/logo.svg" alt="" />
      </BackToLandingPageLink>

      <div class="variant-nav__progress">
        <t-progress-bar />
      </div>
    </nav>

    <PageMain>
      <nuxt />
    </PageMain>
  </div>
</template>

<script>
import InlineSvg from 'vue-inline-svg'
import PageMain from 'chimera/all/components/layout/PageMain'
import BackToLandingPageLink from 'chimera/all/themes/blueflow/components/layout/BackToLandingPageLink'

export default {
  name: 'VariantPD10913Layout',

  components: {
    BackToLandingPageLink,
    InlineSvg,
    PageMain,
  },

  /**
   * The /v2 tree duplicates the control funnel, so keep it out of the index.
   *
   * @returns {object}
   */
  head() {
    return {
      meta: [
        {
          hid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
}
</script>
